import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ChannelUserFilterEntity } from '../../domain/entities/ChannelUserFilterEntity'

export class ChannelUserFilterModel extends ChannelUserFilterEntity {
  userId?: string
  channelId?: number
  constructor(dataDto: ChannelUserFilterEntity) {
    super()
    mapEntityProperties<ChannelUserFilterModel>(this, dataDto, {
      exclude: ['user'],
      map: {
        userId: dataDto.user?.id,
        channelId: dataDto.channels?.id
      }
    })
  }
}
